import { getWHPWithDiscount } from './priceHelper';
function getEffectiveQuantity(itemId, changes, basketLines) {
    if (changes && changes[itemId] !== undefined) {
        return +changes[itemId] || 0;
    }
    if (basketLines && basketLines[itemId] !== undefined) {
        return +basketLines[itemId] || 0;
    }
    return 0;
}
function getUnitPrice(item, hasOrder) {
    if (hasOrder) {
        return item.customerPrice || item.whp || 0;
    }
    return item.whp || 0;
}
export function computeQuantityGridTotals(params) {
    var moloItems = params.moloItems, changes = params.changes, basketLines = params.basketLines, hasOrder = params.hasOrder, _a = params.lineDiscount, lineDiscount = _a === void 0 ? 0 : _a;
    var rowTotals = {};
    var rowQuantities = {};
    var sessionQuantity = 0;
    var sessionAmount = 0;
    Object.keys(moloItems).forEach(function (rowKey) {
        var rowItems = moloItems[rowKey] || [];
        var rowAmount = 0;
        var rowQty = 0;
        rowItems.forEach(function (item) {
            var qty = getEffectiveQuantity(item.itemId, changes, basketLines);
            if (qty <= 0) {
                return;
            }
            var unit = getWHPWithDiscount(getUnitPrice(item, hasOrder), lineDiscount);
            rowAmount += qty * unit;
            rowQty += qty;
        });
        rowTotals[rowKey] = rowAmount;
        rowQuantities[rowKey] = rowQty;
        sessionQuantity += rowQty;
        sessionAmount += rowAmount;
    });
    return {
        sessionQuantity: sessionQuantity,
        sessionAmount: sessionAmount,
        rowTotals: rowTotals,
        rowQuantities: rowQuantities,
    };
}
//# sourceMappingURL=computeQuantityGridTotals.js.map